import React from 'react';
import { Typography, Tag, Tooltip } from 'antd';
import { ThunderboltOutlined } from '@ant-design/icons';
import { formatCurrency } from '../../utils/format';
import { isCloseToReserve } from './LotUtil';
import ClosedLotStatus from './ClosedLotStatus';

const { Text } = Typography;

/**
 * Component to display content for an active lot
 * @param {Object} props
 * @param {Object} props.lot - The lot object
 * @param {Object} props.currentUser - Current logged in user
 * @param {number} props.auctionOwnerId - ID of the auction owner
 * @param {Function} props.renderTimer - Function to render the timer
 * @param {Set} props.statusLoadingLots - Set of lot IDs that are loading status
 * @param {Set} props.activeAutoBids - Set of lot IDs with active auto bids
 */
const ActiveLotContent = ({ lot, currentUser, auctionOwnerId, renderTimer, statusLoadingLots, activeAutoBids }) => {
    const closeToReserve = isCloseToReserve(lot);
    const hasActiveAutoBid = activeAutoBids && activeAutoBids.has(lot.id);
    
    return (
        <>
            <div style={{ textAlign: 'center', marginBottom: '8px' }} className="lot-title">
                <Text strong style={{ 
                    display: 'block',
                    fontSize: '14px',
                    marginBottom: '2px',
                    fontWeight: 'bold'
                }}>
                    Lot #{lot.lot_number}
                </Text>
                <Text strong style={{ 
                    display: 'block',
                    fontSize: '11px',
                    lineHeight: '1.2',
                    maxHeight: '42px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: '-webkit-box',
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: 'vertical'
                }}>
                    {lot.title || 'Untitled Lot'}
                </Text>
            </div>

            <div style={{ textAlign: 'center' }} className="lot-price">
                <Text strong style={{ color: '#1890ff' }}>
                    {formatCurrency(lot.current_price || lot.starting_price)}
                </Text>
                {closeToReserve && (
                    <div style={{ marginTop: '4px' }}>
                        <Tag color="gold" style={{ fontSize: '9px', padding: '2px 6px', fontWeight: 'bold' }}>
                            Close to Reserve
                        </Tag>
                    </div>
                )}
            </div>

            {(lot.status === 'closed' || lot.status === 'cancelled' || lot.status === 'timeout') && (
                <ClosedLotStatus 
                    lot={lot}
                    currentUser={currentUser}
                    auctionOwnerId={auctionOwnerId}
                    isLoading={statusLoadingLots.has(lot.id)}
                />
            )}

            {lot.status !== 'closed' && lot.status !== 'cancelled' && lot.status !== 'timeout' && renderTimer(lot)}
            
            {hasActiveAutoBid && (
                <div style={{ 
                    textAlign: 'center', 
                    marginTop: '4px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <Tooltip title="Auto Max-Bid Active">
                        <ThunderboltOutlined 
                            style={{ 
                                color: '#52c41a',
                                fontSize: '18px',
                                animation: 'pulse 2s ease-in-out infinite'
                            }} 
                        />
                    </Tooltip>
                </div>
            )}
        </>
    );
};

export default ActiveLotContent;

